import React from "react";
import { Descriptions } from "antd";

const BasicInfoTab = ({ student }) => {
  console.log("check student info", student);

  // Extract email + phone from user_accounts
  function extractUserContacts(user_accounts = []) {
    let email = null;
    let phoneNumber = null;

    user_accounts.forEach((acc) => {
      if (acc.account_type_id === 1) {
        email = acc.username;
      } else if (acc.account_type_id === 2) {
        phoneNumber = acc.username;
      }
    });

    return { email, phoneNumber };
  }

  const { email, phoneNumber } = extractUserContacts(student.user_accounts);

  return (
    <Descriptions bordered column={1}>
      <Descriptions.Item label="Full Name">
        {student.full_name}
      </Descriptions.Item>

      <Descriptions.Item label="Email">
        {email || "N/A"}
      </Descriptions.Item>

      <Descriptions.Item label="Phone">
        {phoneNumber || "N/A"}
      </Descriptions.Item>

      <Descriptions.Item label="Registration">
        {student.registration_date}
      </Descriptions.Item>

      <Descriptions.Item label="Last Login">
        {student.last_login}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default BasicInfoTab;
